module.exports = __webpack_public_path__ + "static/media/Stage-f.9e3f050c.webp";